import alert1 from '@/assets/audio/alert.mp3';
import alert2 from '@/assets/audio/ringtone.mp3';

const optionsRingtones = [
  { id: 1, nome: 'Padrão', file: alert1 },
  { id: 2, nome: 'Contínuo', file: alert2 },
];

console.log('optionsRingtones', optionsRingtones);

const optionsDrivers =  [
  { id: 1, nome: 'Impressão Padrão (navegador)' },
  { id: 2, nome: 'QZ Tray', descricao: 'Requer permissão para acessar outros apps e serviços nesse dispositivo' },
  { id: 3, nome: 'Impressão Nova Aba (navegador)' },
];

const optionsPrinters = [
  { id: 1, nome: 'Manual' },
  { id: 2, nome: 'Automática (ao aceitar um pedido)' },
];

const optionsConfirmation = [
  { id: 1, nome: 'Manual' },
  { id: 2, nome: 'Automática' },
];

const optionsLayout = [
  { id: 1, nome: 'Normal' },
  { id: 2, nome: 'Limpo' },
  { id: 3, nome: 'Simplificado' },
];

export default {
  optionsRingtones,
  optionsDrivers,
  optionsPrinters,
  optionsConfirmation,
  optionsLayout,
};
